<template>
    <div :class="`${surveyMode ? 'text-area-custom-sublabel-mode' : ''}`">
        <p v-if="surveyMode" class="surveys-common-label pb-0 mb-1" >
            {{`${requiredCharLabel}`}}
            <span v-if="sublabel" class="surveys-common-sublabel"><br> {{sublabel}}</span>
        </p>
        <v-textarea
            :label="surveyMode ? '' : requiredCharLabel"
            filled
            color="success"
            v-model="value" 
            hide-details="auto" 
            outlined 
            dense 
            :rules="[...rule]"
            :error-messages="errorMessages"
            :rows="rows != null ? rows : dynamicRows"
            auto-grow
            :readonly="readonly"
        ></v-textarea>
        <p class="pb-0 mb-0 caption text-right" v-if="maxChars!=null">
            {{ countChars }}/{{ maxChars }}
        </p>
    </div>

</template>
<script>
export default {
    props: ['valueInput', 'rule', 'refinput', 'maxChars', 'label', 'errorMessages', 'rows', 'readonly', 'sublabel', 'surveyMode'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    data() {
        return {
            dynamicRows: 2,
            
        }
    },
    computed: {

        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                this.$emit('valueChange', value+"".trim())
            }
        },
        requiredCharLabel:{
            get: function(){
                if(this.label == "" || this.label == undefined)
                    return "";
                const response = this.label + " *";
                for (let i = 0; i < (this?.rule?.length??[]); i++) {
                    if(this.rule[i]("") != true){
                        return response;
                    }
                }
                return this.label;
            }
        },
        countChars:{
            get: function() {
                return this.valueInput?.length
            },
            
        }
    },
    methods: {
        limitRows() {
            console.log('ok')
            const textareaEl = this.$refs.myTextarea.$refs.input;
            const lineHeight = 24; // Match your CSS line-height
            const computedRows = Math.ceil(textareaEl.scrollHeight / lineHeight);
            
            // Lock expansion at a maximum of 5 rows
            this.dynamicRows = computedRows >= 5 ? 5 : computedRows;
        },
    },
}
</script>


<style lang="scss">

    .text-area-custom-sublabel-mode{

    }

    .text-area-custom-sublabel-mode .v-text-field .v-input__control .v-input__slot textarea{
        // //margin-bottom: 8px;
        margin-top: 0px !important;
        padding: 0;
    }
    .text-area-custom-sublabel-mode .v-text-field .v-input__control .v-input__slot textarea{
    //margin-bottom: 8px;
        margin-top: 5px !important;
        padding: 0;
    }


</style>